import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { NcdtermsheetService } from 'src/app/services/NCD/ncdtermsheet.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-termsheet-library',
  templateUrl: './termsheet-library.component.html',
  styleUrls: ['./termsheet-library.component.css']
})
export class TermsheetLibraryComponent implements OnInit {

  public environmentSettings: any;
  defaultSelected: any;
  isDefaultChecked: boolean;
  isSearchDivVisible = false;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  // The trigger needed to re-render the table

  error: any = { isError: false, errorMessage: '' };
  meetingArray: any;
  selectedMeeting: any = null;
  meetingDateModel: any;

  dtFieldList: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  addNewTermsheetFieldForm: FormGroup;
  newFieldArray: Array<any> = [];
  newFieldAttribute: any;
  termsheetDataListArray: any[];
  deleteTermsheetFieldId: any;
  listOfValuesArray: any[];
  termsheetIdToUpdate: any;
  firstGetCall: Boolean = false;
  PreviousIndex: any;
  termsheetFieldById: any;
  public newFieldNameSearchParm: any;
  disabledOnClick: Boolean = false;

  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  constructor(private ncdTermsheetService: NcdtermsheetService, private router: Router, 
    private alert: AlertComponent, private commonFunction: CommonFunction, private formBuilder: FormBuilder, private customValidation: CustomValidation) {

  }

  ngOnInit() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    this.environmentSettings = environment;

    this.commonFunction.validateURL('Meetings', '');

    this.dtFieldList = {
      destroy: true,
      scrollY: "400px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'NCD-Termsheet List',
          title: 'NCD-Termsheet List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };

    this.getTermsheetDataList();
    
    this.addNewTermsheetFieldForm = this.formBuilder.group({
      fieldName: ['', [Validators.required]],
      displayNo: ['', [Validators.required]],
      display: ['', []],
      newField: new FormArray([]),
    });

  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  initialiseNewFieldArray(): FormGroup {
    const group = new FormGroup({
    })
    return group;
  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }


  onlyNumberWithoutZero(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 48 && keyCode < 58) || (keyCode > 96 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  doAdvSearchAction() {
    var searchnewFieldObject = {
      FieldName: "",
      'isSearch': true,
    }

    if (this.newFieldNameSearchParm) {
      searchnewFieldObject.FieldName = this.newFieldNameSearchParm;
    }

    this.termsheetDataListArray = [];
    $("#termsheetTable").DataTable().destroy();
    this.ncdTermsheetService.getTermsheetData(searchnewFieldObject).subscribe((termsheetList:any) => {
      this.termsheetDataListArray = termsheetList.data;
      this.dtTrigger.next();
    });
  }

  clearAdvSearch() {
    this.newFieldNameSearchParm = '';
    this.doAdvSearchAction();
  }

  checkSearchFieldBlank() {
    if (this.newFieldNameSearchParm == '') {
      this.doAdvSearchAction();
    }
  }

  addNewFields() {
    var formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    formGroup.addControl("newFieldValue" + formArraySize, new FormControl('', [Validators.required]));
    formGroup.addControl("defaultValue" + formArraySize, new FormControl('', []));
    formGroup.addControl("staticValue" + formArraySize, new FormControl('', []));
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '', 'staticValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }

  removeField(index) {

      var fieldToDelete = this.addNewTermsheetFieldForm.controls.newField.value[index];
      this.newFieldArray.splice(index, 1);
      var formArray = <FormArray>this.addNewTermsheetFieldForm.controls.newField;
      formArray.removeAt(index)
  
      this.newFieldArray = [];
      var j = 0;
      var newFieldData = this.addNewTermsheetFieldForm.controls.newField.value;
      for (let i = 0; i < newFieldData.length; i++) {
       
        var fieldName = this.addNewTermsheetFieldForm.controls.newField.value[i]['newFieldValue' + j];
        var defaultValue = this.addNewTermsheetFieldForm.controls.newField.value[i]['defaultValue' + j];
        if (fieldName == undefined) {
          var deletedIndex = i;
          j = j + 1;
          fieldName = this.addNewTermsheetFieldForm.controls.newField.value[i]['newFieldValue' + j];
          defaultValue = this.addNewTermsheetFieldForm.controls.newField.value[i]['defaultValue' + j];
        }
        var partAFieldsArray = {
          FieldName: fieldName,
          DefaultValue: defaultValue,
        }
        this.newFieldArray.push(partAFieldsArray);
        j++;
      }
     
      const formArrayNewField: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
      while (formArrayNewField.length !== 0) {
        formArrayNewField.removeAt(0)
      }
      var self = this;
      if (this.newFieldArray.length > 0) {
        var count = 0;
        _.forEach(this.newFieldArray, function (valueList) {
  
          const formArray: FormArray = <FormArray>self.addNewTermsheetFieldForm.get('newField');
          formArray.push(self.initialiseNewFieldArray());
          var formGroup: FormGroup = <FormGroup>formArray.controls[count];
  
          formGroup.addControl("newFieldValue" + count, new FormControl('', [Validators.required]));
          formGroup.addControl("defaultValue" + count, new FormControl('', []));
          formGroup.addControl("staticValue" + count, new FormControl('', []));
  
          formGroup.controls["newFieldValue" + count].setValue(valueList.FieldName);
          formGroup.controls["staticValue" + count].setValue(valueList.FieldName);
  
          formGroup.controls["newFieldValue" + count].updateValueAndValidity();
          formGroup.controls["staticValue" + count].updateValueAndValidity();
  
          if (self.newFieldArray[count].FieldName === self.termsheetFieldById.DefaultValue) {
            formGroup.controls["defaultValue" + count].setValue(true);
            self.defaultSelected = self.termsheetFieldById.DefaultValue;
          }
  
          count++;
        })
  
        if (fieldToDelete['newFieldValue' + deletedIndex] == this.defaultSelected) {
          let lastLength = this.newFieldArray.length
          let defaultInputElement = <HTMLInputElement>document.getElementById("newFieldValue" + lastLength);
          this.defaultSelected = defaultInputElement.value;
        }else{
          this.defaultSelected = '';
        }
    }
  }

  deafultSelectChange(ev, index) {
    if (this.PreviousIndex !== undefined) {
      if (index !== this.PreviousIndex) {
        const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
        var formGroup: FormGroup = <FormGroup>formArray.controls[this.PreviousIndex];
        formGroup.controls["defaultValue" + this.PreviousIndex].setValue(false);
      }
    } else {
      for (var i = 0; i < this.newFieldArray.length; i++) {
        if (this.newFieldArray[i]['newFieldValue' + i] === this.termsheetFieldById.DefaultValue) {
          const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
          var formGroup: FormGroup = <FormGroup>formArray.controls[i];
          formGroup.controls["defaultValue" + i].setValue(false);
        }
      }
    }
    this.PreviousIndex = index;
    this.isDefaultChecked = true;
    const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
    var formGroup: FormGroup = <FormGroup>formArray.controls[index];
    formGroup.controls["defaultValue" + index].setValue(true);
    this.defaultSelected = formGroup.controls["newFieldValue" + index].value;

    if (ev.target.checked == false) {
      this.isDefaultChecked = false;
      var lastLength = this.newFieldArray.length - 1;
      const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
      let formGroup: FormGroup = <FormGroup>formArray.controls[lastLength];
      formGroup.controls["defaultValue" + lastLength].setValue(true);
      this.defaultSelected = formGroup.controls["newFieldValue" + lastLength].value;
    }
  }

  fieldValueChange(ind) {
    const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
    var formGroup: FormGroup = <FormGroup>formArray.controls[ind];
    if (formGroup.controls["defaultValue" + ind].value == true) {
      const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
      let formGroup: FormGroup = <FormGroup>formArray.controls[ind];
      formGroup.controls["defaultValue" + ind].setValue(true);
      this.defaultSelected = formGroup.controls["newFieldValue" + ind].value;
    };
    formGroup.controls["staticValue" + ind].setValue(formGroup.controls["newFieldValue" + ind].value);
  }

  getTermsheetDataList() {
    this.termsheetDataListArray = [];
    $("#termsheetTable").DataTable().destroy();
    this.ncdTermsheetService.getTermsheetData({ isSearch: false }).subscribe((termsheetList:any) => {
      this.termsheetDataListArray = termsheetList.data;
      this.dtTrigger.next();
    });
  }

  loadTermsheetByID(termsheetId) {
    this.PreviousIndex = undefined;
    this.firstGetCall = true;
    this.termsheetIdToUpdate = termsheetId;
    this.newFieldArray = [];
    const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
    formArray.controls = [];
    this.ncdTermsheetService.getTermsheetDetailsById(termsheetId).subscribe(response => {
      if (response.status == 0) {

        this.termsheetFieldById = response.data[0];
        this.newFieldArray = response.data[0].ListOfValues;
        var self = this;
        if (this.newFieldArray.length > 0) {
          var count = 0;
          _.forEach(this.newFieldArray, function (valueList) {

            const formArray: FormArray = <FormArray>self.addNewTermsheetFieldForm.get('newField');
            formArray.push(self.initialiseNewFieldArray());
            var formGroup: FormGroup = <FormGroup>formArray.controls[count];

            formGroup.addControl("newFieldValue" + count, new FormControl('', [Validators.required]));
            formGroup.addControl("defaultValue" + count, new FormControl('', []));
            formGroup.addControl("staticValue" + count, new FormControl('', []));

            var newFieldValue = valueList['newFieldValue' + count]
            var staticValue = valueList['staticValue' + count]
            formGroup.controls["newFieldValue" + count].setValue(newFieldValue);
            formGroup.controls["staticValue" + count].setValue(staticValue);

            formGroup.controls["newFieldValue" + count].updateValueAndValidity();
            formGroup.controls["staticValue" + count].updateValueAndValidity();

            if (self.newFieldArray[count]['newFieldValue' + count] === self.termsheetFieldById.DefaultValue) {
              formGroup.controls["defaultValue" + count].setValue(true);
              self.defaultSelected = self.termsheetFieldById.DefaultValue;
            }

            count++;
          })
        }
        else {
          this.addNewFields();
        }

        this.addNewTermsheetFieldForm.controls.fieldName.setValue(this.termsheetFieldById.FieldName);
        this.addNewTermsheetFieldForm.controls.displayNo.setValue(this.termsheetFieldById.DisplayNo);

        if (this.termsheetFieldById.Display == "Part A") {
          this.addNewTermsheetFieldForm.controls.display.setValue('Part A');
        } else if (this.termsheetFieldById.Display == "Part B") {
          this.addNewTermsheetFieldForm.controls.display.setValue('Part B');
        } else if(this.termsheetFieldById.Display == "Documents"){
          this.addNewTermsheetFieldForm.controls.display.setValue('Documents');
        }else{
          this.addNewTermsheetFieldForm.controls.display.setValue('Neither');
        }
      }
    })
  }

  updateTermsheetField() {
    this.disabledOnClick =true;
    // if (this.newFieldArray == [] || this.newFieldArray.length == 0) {
      if ( this.newFieldArray.length == 0) {
      this.defaultSelected = '';
    }

    if (this.isDefaultChecked == false || ((this.defaultSelected == undefined || this.defaultSelected == '') && ( this.newFieldArray.length != 0))) {
      let lastLength = this.newFieldArray.length - 1
      const formArray: FormArray = <FormArray>this.addNewTermsheetFieldForm.get('newField');
      var formGroup: FormGroup = <FormGroup>formArray.controls[lastLength];
      formGroup.controls["defaultValue" + lastLength].setValue(true);
      this.defaultSelected = formGroup.controls["newFieldValue" + lastLength].value;
    }

    var newFieldData = {
      newField: this.addNewTermsheetFieldForm.controls.newField.value,
      defaultValue: this.defaultSelected,
      fieldName: this.addNewTermsheetFieldForm.controls.fieldName.value,
      displayNo: this.addNewTermsheetFieldForm.controls.displayNo.value,
      display: this.addNewTermsheetFieldForm.controls.display.value,
    }

    this.ncdTermsheetService.updateLibraryField(newFieldData, this.termsheetIdToUpdate)
      .subscribe((newField:any) => {
        this.disabledOnClick =false;
        if (newField.status == 0) {
           
          $("#createNewFieldsId").modal('toggle');
          this.getTermsheetDataList();
          this.alert.success(newField.message);
        } else {
        
          if(newField.errFields){
            this.alert.error( JSON.stringify(newField.errFields) + ' fields are required');
          } else if(newField.error){
            this.alert.error( JSON.stringify(newField.error) + ' fields are required');
          }else{
            this.alert.error(newField.message);
          }
        }
      });
  }

  confirmDelete(id) {
    this.deleteTermsheetFieldId = id;
    $("#deleteTermsheetConfirmation").modal('toggle');
  }

  deleteTermsheetField() {
    this.ncdTermsheetService.removeTermsheetDetails(this.deleteTermsheetFieldId)
      .subscribe(response => {
        if (response.status == 0) {
          $("#termsheetTable").DataTable().destroy();
          this.alert.success("Termsheet Field deleted successfully.");
        }
      });
  }

}
